window.mapInstance = null
window.markers = []
window.reverseMarkers = []
window.infowindow = null
window.infowindowProgrammes = {}
window.activeInfoWindow = null
let arrayWidgetId = []
let currentCaptcha
let phoneInputs = []

const showPoiOnly = [
	{
		featureType: 'poi',
		elementType: 'labels',
		stylers: [
			{
				visibility: 'on'
			}
		]
	},
	{
		featureType: 'road',
		elementType: 'labels',
		stylers: [
			{
				visibility: 'off'
			}
		]
	}
]
const showStreetsOnly = [
	{
		featureType: 'road',
		elementType: 'labels',
		stylers: [
			{
				visibility: 'on'
			}
		]
	},
	{
		featureType: 'poi',
		elementType: 'labels',
		stylers: [
			{
				visibility: 'off'
			}
		]
	}
]
const allHide = [
	{
		featureType: 'road',
		elementType: 'labels',
		stylers: [
			{
				visibility: 'off'
			}
		]
	},
	{
		featureType: 'poi',
		elementType: 'labels',
		stylers: [
			{
				visibility: 'off'
			}
		]
	}
]
const showAll = [
	{
		featureType: 'road',
		elementType: 'labels',
		stylers: [
			{
				visibility: 'on'
			}
		]
	},
	{
		featureType: 'poi',
		elementType: 'labels',

		stylers: [
			{
				visibility: 'on'
			}
		]
	}
]

function initMap() {
	// Marquer que Google Maps est chargé
	window.googleMapsLoaded = true

	// Utilisez une variable globale pour stocker l'instance de carte
	const map = document.getElementById('map')
	const mapProgramme = document.getElementById('mapProgramme')
	const mapAgence = document.getElementById('mapAgence')

	if (map) {
		window.mapInstance = new google.maps.Map(map, {
			zoom: 6,
			center: { lat: 46.494739, lng: 2.602833 },
			mapTypeControl: false,
			gestureHandling: 'greedy'
		})

		window.mapInstance.addListener('tilesloaded', function() {
			const showPointInterestMap = $('#showPointInterestMap')
				.find('input')
				.is(':checked')
			const showStreetMap = $('#showStreetMap').find('input').is(':checked')
			const showSatelliteMap = $('#showSatelliteMap')
				.find('input')
				.is(':checked')

			if (showSatelliteMap) {
				window.mapInstance.setMapTypeId('satellite')
			}

			if (showPointInterestMap && !showStreetMap) {
				window.mapInstance.setOptions({
					styles: showPoiOnly
				})
			} else if (showPointInterestMap && showStreetMap) {
				window.mapInstance.setOptions({
					styles: showAll
				})
			} else if (!showPointInterestMap && showStreetMap) {
				window.mapInstance.setOptions({
					styles: showStreetsOnly
				})
			} else {
				window.mapInstance.setOptions({
					styles: allHide
				})
			}
		})
	}

	if (mapProgramme) {
		const latLng = document.querySelector('[name="latLng"]').value.split(';')
		const programmeName = document.querySelector('[name="programmeName"]')
		const mapProgrammeInstance = new google.maps.Map(mapProgramme, {
			zoom: 15,
			center: { lat: parseFloat(latLng[0]), lng: parseFloat(latLng[1]) },
			gestureHandling: 'cooperative'
		})
		const markerProgramme = new google.maps.Marker({
			position: { lat: parseFloat(latLng[0]), lng: parseFloat(latLng[1]) },
			map: mapProgrammeInstance,
			icon: {
				url: '/assets/images/loc.png',
				scaledSize: new google.maps.Size(30, 35)
			},
			title: programmeName.value
		})
	}

	if (mapAgence) {
		const latLng = document.querySelector('[name="latLngAgence"]').value.split(';')
		const programmeName = document.querySelector('[name="programmeName"]')

		const mapAgenceInstance = new google.maps.Map(mapAgence, {
			zoom: 16,
			center: { lat: parseFloat(latLng[0]), lng: parseFloat(latLng[1]) },
			gestureHandling: 'cooperative'
		})
		const markerProgramme = new google.maps.Marker({
			position: { lat: parseFloat(latLng[0]), lng: parseFloat(latLng[1]) },
			map: mapAgenceInstance,
			icon: {
				url: '/assets/images/loc.png',
				scaledSize: new google.maps.Size(30, 35)
			},
			title: 'Agence'
		})
	}
}

// Utilisez une fonction de rappel pour s'assurer que l'API Google Maps est chargée
function loadGoogleMapsScript() {
	const map = document.getElementById('map')
	const mapProgramme = document.getElementById('mapProgramme')
	const mapAgence = document.getElementById('mapAgence')
	const seoMap = document.getElementById('seoMap')

	if (!map && !mapProgramme && !mapAgence && !seoMap) {
		return
	}
	var apiKey = 'AIzaSyAS4LFapKVWKYGRJHKklqXcdxzh9wS57ZE'

	// Créez un élément de script pour charger l'API Google Maps de manière asynchrone
	var script = document.createElement('script')
	script.src =
		'https://maps.googleapis.com/maps/api/js?key=' +
		apiKey +
		'&callback=initMap'
	script.async = true
	script.defer = true

	// Attachez le script à l'élément head du document
	document.head.appendChild(script)
}

// Attachez la fonction de chargement au chargement du document
loadGoogleMapsScript()

$(document).ready(function() {
	$.fn.replaceClass = function(pFromClass, pToClass) {
		return this.removeClass(pFromClass).addClass(pToClass)
	}

	const subDomain = window.location.hostname.split('.')[0];

	$.fn.extend({
		showModal: function() {
			return this.each(function() {
				if (this.tagName === 'DIALOG') {
					// Créer le backdrop
					const backdrop = $('<div class="modal-backdrop"></div>')

					// Ajouter le backdrop à la page
					$('body').append(backdrop)

					$('body').addClass('overflow-hidden')

					// Afficher le dialogue
					this.show()

					// Enregistrer le backdrop comme propriété de l'élément dialog
					$(this).data('backdrop', backdrop)
				}
			})
		},
		hideModal: function() {
			return this.each(function() {
				if (this.tagName === 'DIALOG') {
					// Récupérer le backdrop associé à ce dialogue
					const backdrop = $(this).data('backdrop')

					$('body').removeClass('overflow-hidden')

					// Masquer le dialogue
					this.close()

					// Supprimer le backdrop de la page
					backdrop.remove()
				}
			})
		}
	})
	const queryParams = new URLSearchParams(window.location.search)
	const modalParams = queryParams.get('modal') || queryParams.get('popup')
	if (modalParams) {
		const modal = $('dialog#' + modalParams)
		if ((modalParams === 'login' || modalParams === 'register') && user !== undefined) {
			// window.history.replaceState({}, document.title, window.location.pathname);
			window.location.href = '/favoris'
		} else {
			modal.showModal()
		}
	}

	$('.autoDismiss').each(function() {
		const autoDismiss = $(this)
		setTimeout(function() {
			autoDismiss.remove()
		}, 4000)
	})

	$(document).click(function(e) {
		if (
			$(e.target).closest('.multiselect').length === 0 &&
			$('.multiselect .dropdown').hasClass('block')
		) {
			$('.multiselect .dropdown').replaceClass('block', 'hidden')
		}
		if (
			$(e.target).closest('.select').length === 0 &&
			$('.select .dropdown').hasClass('block')
		) {
			$('.select .dropdown').replaceClass('block', 'hidden')
		}
		if (
			$(e.target).closest('.inputSearch').length === 0 &&
			$('.inputSearch .dropdown').hasClass('block')
		) {
			$('.inputSearch .dropdown').replaceClass('block', 'hidden')
		}
	})

	$(document).on('mouseenter', '[data-tooltip="true"]', function() {
		if ($(window).width() > 768) {
			// Éviter de créer plusieurs tooltips
			if ($(this).find('.tooltip').length > 0) {
				return
			}

			let message = $(this).attr('data-tooltip-message')
			message.split(' : ')[1] ? message = message.split(' : ')[1] : message = message.split(' : ')[0]
			const placement = $(this).attr('data-tooltip-placement')
			const background = $(this).attr('data-tooltip-background') ?? '#514A68'
			const textColor = $(this).attr('data-tooltip-text-color') ?? '#fff'
			const borderColor = $(this).attr('data-tooltip-border') ?? null
			const tooltipWrapper = $(this)
			const tooltip = document.createElement('div')

			// Utiliser des styles inline pour Safari au lieu de classes Tailwind arbitraires
			tooltip.className = 'absolute text-sm p-2 rounded z-[9999] tooltip visibility-hidden left-1/2 transform -translate-x-1/2 max-w-[300px] w-max opacity-90 font-normal text-center whitespace-normal'
			tooltip.style.backgroundColor = background
			tooltip.style.color = textColor
			if (borderColor) {
				tooltip.style.border = '1.5px solid ' + borderColor
			}
			tooltip.style.bottom = 'calc(100% + 5px)'
			tooltip.classList.add(placement)
			tooltip.innerHTML = message
			tooltipWrapper.append(tooltip)

			// Forcer un reflow pour Safari
			void tooltip.offsetHeight

			if (($(this).offset().top - $(window).scrollTop()) < tooltip.offsetHeight) {
				tooltip.style.bottom = 'auto'
				tooltip.style.top = 'calc(100% + 5px)'
			} else if (($(this).offset().left + tooltip.offsetWidth) > $(window).width()) {
				tooltip.classList.remove('left-1/2', '-translate-x-1/2')
				tooltip.style.right = 'calc(100% + 5px)'
				tooltip.style.left = 'auto'
				tooltip.style.transform = 'none'
			}

			// Rendre visible après positionnement
			requestAnimationFrame(() => {
				tooltip.classList.replace('visibility-hidden', 'visibility-visible')
			})
		}
	})

	$(document).on('mouseleave', '[data-tooltip="true"]', function() {
		$(this).find('.tooltip').remove()
		$('body > .tooltip').remove()
	})

	function createTooltip(wrapper) {
		if ($('body > .tooltip').length > 0) return
		let message = wrapper.attr('data-tooltip-message')
		message.split(' : ')[1] ? message = message.split(' : ')[1] : message = message.split(' : ')[0]
		const background = wrapper.attr('data-tooltip-background') ?? '#514A68'
		const textColor = wrapper.attr('data-tooltip-text-color') ?? '#fff'
		const borderColor = wrapper.attr('data-tooltip-border') ?? null
		const tooltip = document.createElement('div')
		tooltip.className = 'fixed text-sm p-2 rounded z-[9999] tooltip visibility-hidden max-w-[280px] w-max opacity-90 font-normal whitespace-normal'
		tooltip.style.backgroundColor = background
		tooltip.style.color = textColor
		if (borderColor) {
			tooltip.style.border = '1.5px solid ' + borderColor
		}
		tooltip.innerHTML = message
		document.body.appendChild(tooltip)
		void tooltip.offsetHeight

		const margin = 8
		const rect = wrapper[0].getBoundingClientRect()
		const winWidth = window.innerWidth
		const tipWidth = tooltip.offsetWidth
		const tipHeight = tooltip.offsetHeight

		// Vertical: au-dessus par défaut, sinon en dessous
		let topPos
		if (rect.top < tipHeight + margin) {
			topPos = rect.bottom + 5
		} else {
			topPos = rect.top - tipHeight - 5
		}

		// Horizontal: centré sur le wrapper, clampé dans le viewport
		let leftPos = rect.left + rect.width / 2 - tipWidth / 2
		leftPos = Math.max(margin, Math.min(leftPos, winWidth - tipWidth - margin))

		tooltip.style.top = topPos + 'px'
		tooltip.style.left = leftPos + 'px'

		requestAnimationFrame(() => {
			tooltip.classList.replace('visibility-hidden', 'visibility-visible')
		})
		return tooltip
	}

	$(document).on('click', '[data-tooltip-click="true"]', function(e) {
		e.stopPropagation()
		const wrapper = $(this)
		// La tooltip est dans body avec data-tooltip-owner pointant vers ce wrapper
		const existing = $('body > .tooltip[data-tooltip-owner]').filter(function() {
			return $(this).data('tooltipOwner') === wrapper[0]
		})
		if (existing.length > 0) {
			existing.remove()
			return
		}
		const tooltip = createTooltip(wrapper)
		if (tooltip) $(tooltip).data('tooltipOwner', wrapper[0])
	})

	$(document).on('click', function(e) {
		if (!$(e.target).closest('[data-tooltip-click="true"]').length) {
			$('body > .tooltip').remove()
		}
	})

	$(window).on('scroll', function() {
		$('body > .tooltip').remove()
	})

	$('.carousel').owlCarousel({
		loop: true,
		margin: 30,
		nav: false,
		dots: false,
		autoplay: true,
		autoplayTimeout: 6000,
		autoplayHoverPause: true,
		responsive: {
			0: {
				items: 1
			},
			768: {
				items: 2
			},
			1024: {
				items: 3
			},
			1440: {
				items: 4
			}
		}
	})

	$('.offer').owlCarousel({
		loop: false,
		margin: 30,
		nav: false,
		dots: false,
		autoplay: true,
		autoplayTimeout: 6000,
		autoplayHoverPause: true,
		responsive: {
			0: {
				items: 1
			},
			768: {
				items: 2
			},
			1024: {
				items: 3
			},
			1440: {
				items: 4
			}
		}
	})

	$('.multiselect').each(function() {
		const placeholder = $(this).data('placeholder')

		$(this).change(function() {
			const selectedValues = $(this)
				.find('input:checked')
				.map(function() {
					return $(this).data('label')
				})
				.get()
				.join(', ')
			if (selectedValues.length > 0) {
				$(this).find('.recap').html(selectedValues)
			} else {
				$(this).find('.recap').html(placeholder)
			}
		})

		$(this).click(function() {
			if ($(this).find('.dropdown').hasClass('block')) {
				$('.multiselect .dropdown').replaceClass('block', 'hidden')
			} else {
				$('.multiselect .dropdown').replaceClass('block', 'hidden')
				$(this).find('.dropdown').replaceClass('hidden', 'block')
			}
		})
	})

	$('.select').each(function() {
		const placeholder = $(this).data('placeholder')
		const selectMain = $(this)

		$(this).change(function() {
			const selectedValues = $(this).find('input:checked')
			const value = selectedValues.data('label')
				? selectedValues.data('label')
				: selectedValues.data('valueformatted')
					? selectedValues.data('valueformatted')
					: selectedValues.val()

			const recap = $(this).find('.recap')

			if (selectedValues.length > 0) {
				if (!recap.text().includes(selectedValues.data('suffix'))) {
					recap.html(value)
					$(this).find('.suffix').html(selectedValues.data('suffix'))
					$(this).find('.prefix').html(selectedValues.data('prefix'))
					if (!recap.hasClass('ml-1')) {
						recap.addClass('ml-1')
					}
				} else {
					recap.html(value)
				}
			} else {
				$(this).find('.recap').html(placeholder)
			}
		})

		$(this).click(function() {
			if ($(this).find('.dropdown').hasClass('block')) {
				$('.select .dropdown').replaceClass('block', 'hidden')
			} else {
				$('.select .dropdown').replaceClass('block', 'hidden')
				$(this).find('.dropdown').replaceClass('hidden', 'block')
			}
		})

		$(this)
			.find('input')
			.each(function() {
				$(this).on('click', function() {
					selectMain.find('input').not(this).removeClass('checked')
					$(this).toggleClass('checked')
					if ($(this).hasClass('checked')) {
						$(this).prop('checked', true)
						selectMain.trigger('click')
					} else {
						$(this).prop('checked', false)
						$(this).removeAttr('checked')
						const select = $(this).closest('.select')
						const value = select.data('placeholder')
						select.find('.recap').html(value)
						if (!$(this).data('suffix') || !select.hasClass('amoutSelect')) {
							select.find('.suffix').html('')
						} else {
							select.find('.suffix').html($(this).data('suffix'))
						}

						if (!$(this).data('prefix') || !select.hasClass('amoutSelect')) {
							select.find('.recap').removeClass('ml-1')
							select.find('.prefix').html('')
						} else {
							select.find('.recap').addClass('ml-1')
							select.find('.prefix').html($(this).data('prefix'))
						}
					}
				})
			})
	})

	$('.inputSearch').each(function() {
		const input = $(this).find('input')
		const dropdown = $(this).find('.dropdown')

		let inputCp = null
		let inputVille = null

		if (input.attr('name') === 'ville') {
			inputCp = $(this).closest('form').find('input[name="cp"]')
		} else if (input.attr('name') === 'cpSearch') {
			inputVille = $(this).closest('form').find('input[name="villeSearch"]')
		} else if (input.attr('name') === 'villeSearch') {
			inputCp = $(this).closest('form').find('input[name="cpSearch"]')
		} else if (input.attr('name') === 'cp') {
			inputVille = $(this).closest('form').find('input[name="ville"]')
		}

		input.on('keyup', function() {
			if ($(this).val().length > 2 && $(this).is(':focus')) {
				$('.inputSearch .dropdown')
					.not(dropdown)
					.replaceClass('block', 'hidden')
				$.ajax({
					url: '/api/villes/suggestions',
					dataType: 'json',
					data: {
						ville: $(this).val()
					},
					success: function(data) {
						if (data.length) {
							let html = '<ul>'
							html += data
								.map((item) => {
									return generateSearchListItem(item)
								})
								.join('')
							html += '</ul>'
							dropdown.html(html)
						} else {
							dropdown.html('<p class="text-xs p-4">Aucun résultat</p>')
						}
					}
				})
				dropdown.replaceClass('hidden', 'block')
			} else {
				dropdown.replaceClass('block', 'hidden')
			}
		})

		dropdown.on('click', 'li', function() {
			const ville = $.trim($(this).text().split(' - ')[0])
			const cp = $.trim($(this).text().split(' - ')[1])

			if (inputCp !== null) {
				inputCp.val(cp)
				input.val(ville)
			} else if (inputVille !== null) {
				inputVille.val(ville)
				input.val(cp)
			}
			dropdown.replaceClass('block', 'hidden')
		})
	})

	$('#showSatelliteMap').change(function() {
		const isChecked = $(this).is(':checked')
		if (isChecked) {
			window.mapInstance.setMapTypeId('satellite')
		} else {
			window.mapInstance.setMapTypeId('roadmap')
		}
		$.ajax({
			url: '/api/map/satellite',
			method: 'POST',
			data: {
				showSatelliteMapView: isChecked
			}
		})
	})

	$('#showStreetMap, #showPointInterestMap').change(function() {
		const showPointInterestMap = $('#showPointInterestMap')
			.is(':checked')
		const showStreetMap = $('#showStreetMap').is(':checked')

		if (showPointInterestMap && !showStreetMap) {
			window.mapInstance.setOptions({
				styles: showPoiOnly
			})
		} else if (showPointInterestMap && showStreetMap) {
			window.mapInstance.setOptions({
				styles: showAll
			})
		} else if (!showPointInterestMap && showStreetMap) {
			window.mapInstance.setOptions({
				styles: showStreetsOnly
			})
		} else {
			window.mapInstance.setOptions({
				styles: allHide
			})
		}

		$.ajax({
			url: '/api/map/pointInterest',
			method: 'POST',
			data: {
				saveShowPointInterestMapView: showPointInterestMap
			}
		})

		$.ajax({
			url: '/api/map/street',
			method: 'POST',
			data: {
				saveShowStreetMapView: showStreetMap
			}
		})
	})

	$('form:not([action]):not(#searchFormWrapper)').submit(function(e) {
		e.preventDefault()

		const form = $(this)
		const submit = form.find('button[type="submit"]')
		const isMultipart = form.attr('enctype') === 'multipart/form-data'
		const buttonSubmitLabel = submit.text()

		const widgetId = form.find('button.recaptcha').attr('id')
		const widget = arrayWidgetId.find((widget) => widget.recpatchaId === widgetId)

		// Validation du téléphone
		const formId = form.attr('id')
		const phoneInput = phoneInputs[formId]

		let isValidNumber = true

		if (phoneInput) {
			if (!phoneInput.isValidNumber()) {
				isValidNumber = false
			}
		}

		let data = form.serialize()

		if (!isValidNumber) {
			data.split('&').forEach((item) => {
				if (item.includes('phone')) {
					const phone = item.split('=')[1]
					if (phone) {
						data = data.replace(phone, false)
					}
				}
				if (item.includes('telephoneHidden')) {
					const phone = item.split('=')[1]
					if (phone) {
						data = data.replace(phone, false)
					}
				}
			})
		}

		if (isMultipart) {
			data = new FormData(form[0])

			if (!isValidNumber) {
				data.set('phone', false)
				data.set('telephoneHidden', false)
			}
		}

		submit.text('Chargement...')
		submit.prop('disabled', true)

		$.ajax({
			url: '/api/form/' + form.attr('id'),
			method: 'POST',
			data: data,
			processData: isMultipart ? false : true,
			contentType: isMultipart
				? false
				: 'application/x-www-form-urlencoded; charset=UTF-8',
			dataType: 'json',
			success: function(data) {
				const fieldsWithError = form.find('.border-red-500')
				const recaptchaError = form.find('.recaptcha-error')
				const errorMessage = form.find('.errorMessage')

				fieldsWithError.removeClass('border-red-500')
				fieldsWithError
					.parent()
					.find('.error')
					.removeClass('block')
					.addClass('hidden')
				fieldsWithError
					.closest('.inputSearch')
					.find('.error')
					.removeClass('block')
					.addClass('hidden')
				fieldsWithError
					.closest('.inputRadio')
					.parent()
					.find('.error')
					.removeClass('block')
					.addClass('hidden')
				fieldsWithError
					.closest('.iti')
					.parent()
					.find('.error')
					.removeClass('block')
					.addClass('hidden')
				recaptchaError.removeClass('block').addClass('hidden')
				errorMessage.removeClass('block').addClass('hidden')
				form.find('span.error').addClass('hidden')
				form.find('input:checkbox').css('outline', '')
				fieldsWithError
					.closest('.inputCheckbox')
					.parent()
					.find('.error')
					.removeClass('block')
					.addClass('hidden')
				fieldsWithError
					.closest('.datepickerInputWrapper')
					.parent()
					.find('.error')
					.removeClass('block')
					.addClass('hidden')
				fieldsWithError
					.closest('.select')
					.parent()
					.find('.error')
					.removeClass('block')
					.addClass('hidden')
				fieldsWithError
					.closest('.multiselect')
					.parent()
					.find('.error')
					.removeClass('block')
					.addClass('hidden')


				if (data.error) {
					if (data.error.error) {
						form.find('.errorMessage').replaceClass('hidden', 'block')
						form.find('.errorMessage').html(data.error.error)
					}
					if (data.error.captcha) {
						recaptchaError.removeClass('hidden').html(data.error.captcha)
					} else {
						const errors = data.error
						$.each(errors, function(field, message) {
							const input = form.find(`[name="${field}"]`).length ? form.find(`[name="${field}"]`) : form.find(`[name="${field}[]"]`)
							if (input.closest('.inputSearch').length) {
								input.addClass('border-red-500')
								input
									.closest('.inputSearch')
									.find('.error')
									.removeClass('hidden')
									.html(message)
							} else if (input.closest('.iti').length) {
								form.find('[name="phone"]').addClass('border-red-500')
								input
									.closest('label')
									.find('.error')
									.removeClass('hidden')
									.html(message)
							} else if (input.closest('.inputRadio').length) {
								input
									.closest('.inputRadio')
									.find('[type="radio"]')
									.addClass('border-red-500')
								const firstError = input
									.closest('.inputRadio')
									.parent()
									.find('.error')
									.first()
								firstError.removeClass('hidden').html(message)
							} else if (input.closest('.inputCheckbox').length) {
								input.closest('.inputCheckbox').addClass('border-red-500')
								const firstError = input
									.closest('.inputCheckbox')
									.parent()
									.find('.error')
									.first()
								firstError.removeClass('hidden').html(message)
							} else if (input.closest('.datepickerInputWrapper').length) {
								input.addClass('border-red-500')
								const firstError = input
									.closest('.datepickerInputWrapper')
									.parent()
									.find('.error')
									.first()
								firstError.removeClass('hidden').html(message)
							} else if (input.closest('.select').length) {
								input.closest('.select').addClass('border-red-500')
								const firstError = input
									.closest('.select')
									.parent()
									.find('.error')
									.first()
								firstError.removeClass('hidden').html(message)
							} else if (input.closest('.multiselect').length) {
								input.closest('.multiselect').addClass('border-red-500')
								const firstError = input
									.closest('.multiselect')
									.parent()
									.find('.error')
									.first()
								firstError.removeClass('hidden').html(message)
							} else if (input.is(':checkbox')) {
								// Case sans cadre : le span .error est frere du conteneur flex, pas du parent direct
								input.css('outline', '2px solid #ef4444')
								input.closest('.flex').parent().find('.error').first().removeClass('hidden').html(message)
							} else {
								input.addClass('border-red-500')
								input
									.parent()
									.find('.error')
									.removeClass('hidden')
									.html(message)
							}
						})
					}
				} else {
					if (data.success) {
						form.find('.message').replaceClass('hidden', 'block')
						form.find('.message').html(data.success)
					}

					if (data.redirect) {
						window.location.href = data.redirect
					} else {
						form.trigger('reset')
						setTimeout(function() {
							form.find('.message').replaceClass('block', 'hidden')
							const dialog = form.closest('dialog')
							dialog.hideModal()
						}, 2500)
					}

				}
			},
			complete: function() {
				// grecaptcha.reset(widget.widgetId);
				submit.text(buttonSubmitLabel)
				submit.prop('disabled', false)
			}
		})
	})

	// $("#burgerMenu").click(function () {
	//   window.scrollTo(0, 0);
	// });

	$(document).on('click', '.heart-icon', function(e) {
		e.preventDefault()
		e.stopPropagation()
		const heart = $(this).parent()
		const idBien = heart.attr('data-bien')
		const idProgramme = heart.attr('data-programme')
		const userId = heart.attr('data-user')
		const like = heart.hasClass('liked') || heart.hasClass('active')
		const wrapperFavoris = heart.closest('.wrapper-favoris')
		const text = heart.parent().find('#fav_text')
		const params = new URLSearchParams(window.location.search)
		const source = params.get('source')

		if (userId == '0') {
			$('#login').showModal()
		} else {
			if (idBien) {
				const heartProgramme = wrapperFavoris
					.parent()
					.parent()
					.children('.wrapper-favoris')
					.find('.heart')
				const lastBienOnProgrammeNotLiked =
					wrapperFavoris.parent().children().length <= 1 &&
					!heartProgramme.hasClass('liked') &&
					!heartProgramme.hasClass('active')
				let deleteBienLiked
				if (like) {
					deleteBienLiked = window.confirm(
						'Etes vous sur de vouloir retirer ce bien de vos favoris?'
					)
				}
				if (deleteBienLiked || !like)
					$.ajax({
						url: '/api/likeBien',
						data: {
							idBien,
							userId,
							like,
							source
						},
						method: 'POST',
						cache: false,
						success: function(response) {
							const favoriColNumber = heart
								.parent()
								.parent()
								.parent()
								.parent()
								.parent()
								.parent()
								.parent()
								.find('.favoriCol .numberFav:not(.favoriColText)')
							if (response.like === false) {
								// Pour la page d'un programme permet d'incrémenter le nombre de favoris selon le type
								if (favoriColNumber) {
									favoriColNumber.html(+favoriColNumber.text().trim() - 1)
								}
								// Pour la page des favoris supprime le biens de la page
								if (wrapperFavoris.hasClass('wrapper-biens')) {
									wrapperFavoris.fadeOut('slow', function() {
										// Si derniers biens de la liste d'un programme non liké supprimé le programme associé
										if (lastBienOnProgrammeNotLiked) {
											wrapperFavoris.parent().parent().remove()
											if ($('.wrapper-content-favoris').children().length < 1) {
												window.location.reload()
											}
										} else {
											$(wrapperFavoris).remove()
										}
									})
								}
								heart.removeClass('liked')
								heart.removeClass('active')
								if (text) {
									$(text).text('Ajouter aux favoris')
								}
							} else {
								if (favoriColNumber) {
									favoriColNumber.html(+favoriColNumber.text().trim() + 1)
								}
								heart.addClass('active')
								if (text) {
									$(text).text('Retirer des favoris')
								}
							}
						}
					})
			} else if (idProgramme) {
				let deletedProgrammeLiked
				if (like) {
					deletedProgrammeLiked = window.confirm(
						'Etes vous sur de vouloir retirer ce programme de vos favoris?'
					)
				}
				if (deletedProgrammeLiked || !like)
					$.ajax({
						url: '/api/likeProgramme',
						data: {
							idProgramme,
							userId,
							like,
							source
						},
						method: 'POST',
						cache: false,
						success: function(response) {
							if (response.like === false) {
								const programmeWrapper = heart
									.parent()
									.parent()
									.parent()
									.parent()
									.parent()
									.parent()
								// Si programme unlike dans la page favoris et qu'il n'a aucun biens le supprimé sinon juste unlike le programme sans rien d'autre
								if (
									programmeWrapper.find('.b-wrapper').length > 0 &&
									programmeWrapper.find('.b-wrapper').children().length < 1 &&
									programmeWrapper.hasClass('p-wrapper')
								) {
									programmeWrapper.fadeOut('slow', function() {
										programmeWrapper.remove()
										if ($('.wrapper-content-favoris').children().length < 1) {
											window.location.reload()
										}
									})
								}
								heart.removeClass('liked')
								heart.removeClass('active')
								if (text) {
									$(text).text('Ajouter aux favoris')
								}
							} else {
								heart.addClass('active')
								if (text) {
									$(text).text('Retirer des favoris')
								}
							}
						}
					})
			}
		}
	})

	if ($('#cookies').length) {
		$('body').addClass('overflow-hidden')
	}

	$(document).on('click', '#parametresCookies', function() {
		$('.innerContent').hide()
		$('.innerContent2').parent().show()
		$('#closeCookie, #refuseCookie').hide()
		$(this).addClass('saveCookie')
		$(this).text('Sauvegarder mes préférences')
	})

	$(document).on('click', '.saveCookie', function() {
		const isCookieSuivi = $('#checkCookieSuivi').is(':checked')

		$.ajax({
			url: '/api/cookie',
			method: 'POST',
			data: {
				isCookieSuivi
			},
			success: function(data) {
				$('#cookies').fadeOut()
				$('body').removeClass('overflow-hidden')
			}
		})
	})

	$('#closeCookie').on('click', function(e) {
		e.preventDefault()
		$.ajax({
			url: '/api/cookie',
			method: 'POST',
			data: {
				acceptAllCookie: true
			},
			success: function(data) {
				$('#cookies').fadeOut()
				$('body').removeClass('overflow-hidden')
			}
		})
	})

	$('#refuseCookie').on('click', function(e) {
		e.preventDefault()
		$.ajax({
			url: '/api/cookie',
			method: 'POST',
			data: {
				isCookieSuivi: false
			},
			success: function() {
				$('#cookies').fadeOut()
				$('body').removeClass('overflow-hidden')
			}
		})
	})

	// TODO MOVE TO FAVORIS.JS
	$(document).on('click', '.remove-expire-fav', function() {
		const heart = $(this).parents('.wrapper-favoris').find('.heart-icon')
		$(heart).click()
		if ($(heart).parent().attr('data-programme') !== undefined) {
			$(this).parent().parent().remove()
		}
	})

	$('.orderContent').change(async function(e) {
		const sortedVal = $(this).val().split('_')[1]
		const elements = $('.p-wrapper')
		if (sortedVal) {
			$('.reset-filter').attr('style', 'display: block !important')
			$('.reset-filter').click(function(e) {
				window.location.reload()
			})
			if (sortedVal == 'ASC') {
				$('.wrapper-content-favoris').html(
					elements.sort((a, b) => {
						const aLivraison = $(a).find('input[name="livraisonDate"]').val()
						const bLivraison = $(b).find('input[name="livraisonDate"]').val()
						return (aLivraison > bLivraison) ? 1 : ((bLivraison > aLivraison) ? -1 : 0)
					})
				)
			} else if (sortedVal == 'DESC') {
				$('.wrapper-content-favoris').html(
					elements.sort((a, b) => {
						const aLivraison = $(a).find('input[name="livraisonDate"]').val()
						const bLivraison = $(b).find('input[name="livraisonDate"]').val()
						return (aLivraison < bLivraison) ? 1 : ((bLivraison < aLivraison) ? -1 : 0)
					})
				)
			}
		}
	})

	$(document).on('click', '#submitCertification', function() {
		$.ajax({
			url: '/api/favoris/submitCertification',
			data: {
				submitCertification: true,
				userId: parseInt($(this).attr('data-user'))
			},
			success: function(response) {
				alert(
					'Nous vous remercions pour votre demande de certification, Un conseiller Polyvalence vous recontactera dans les plus brefs délais afin de terminer la procédure.'
				)
				window.location.reload()
			}
		})
	})

	$('.share-facebook').on('click', function() {
		var userId = $(this).attr('data-user')

		$.ajax({
			url: '/api/favoris/shareSocial/facebook',
			data: {
				userId: userId,
				shareSocial: 'Facebook'
			},
			success: function(response) {
				if (typeof FB === 'undefined') {
					window.open('https://www.facebook.com/sharer/sharer.php?u=' + encodeURIComponent(response), '_blank', 'noopener')
					return
				}

				FB.init({ appId: '1368225247247597', xfbml: true, cookie: true })

				FB.ui({
					method: 'send',
					link: response,
					to: 1368225247247597
				})
			}
		})
	})

	$('.share-twitter').on('click', function() {
		var userId = $(this).attr('data-user')

		$.ajax({
			url: '/api/favoris/shareSocial/twitter',
			data: {
				userId: userId,
				shareSocial: 'Twitter'
			},
			success: function(response) {
				window
					.open('http://twitter.com/share?&url=' + response, '_blank')
					.focus()
			}
		})
	})

	// END TODO

	// TODO MOVE TO ACCOUNT.JS
	$('#addNewSouhait').on('click', function(e) {
		e.preventDefault()
		$('#addSouhait').show()
	})

	$('.editSouhait').click(function() {
		$('.pour').each(function() {
			const inputsRadio = $(this).find('input[type=radio]:checked')
			inputsRadio.each(function() {
				$(this).trigger('click')
				$(this).trigger('click')
			})
		})
	})

	$('.pour').each(function() {
		const inputsRadio = $(this).find('input[type=radio]')
		inputsRadio.each(function() {
			$(this).on('click', function() {
				if ($(this).val() == 'habiter') {
					$(this).closest('form').find('#residence').parent().parent().show()
					$(this).closest('form').find('#defisc').parent().parent().hide()
				} else {
					$(this).closest('form').find('#residence').parent().parent().hide()
					$(this).closest('form').find('#defisc').parent().parent().show()
				}
			})
		})
	})

	$('.deleteSouhait').click(function() {
		const idSouhait = $(this).data('souhait')
		const deleteSouhait = window.confirm(
			'Etes vous sur de vouloir supprimer ce souhait?'
		)
		if (deleteSouhait) {
			$.ajax({
				url: '/api/removeSouhait',
				data: {
					idSouhait
				},
				method: 'POST',
				cache: false,
				success: function(response) {
					window.location.reload()
				}
			})
		}
	})

	function changePour(el, elResidence, elDefisc) {
		const value = el.val()
		if (value == 'habiter') {
			elDefisc.parent().addClass('hidden')
			elResidence.parent().removeClass('hidden')
		} else {
			elResidence.parent().addClass('hidden')
			elDefisc.parent().removeClass('hidden')
		}
	}

	// END TODO

	$(document).on('click', '#menuDropdownLinksMobile', function() {
		const isBurgerMenuOpen = $('#menuLinks').hasClass('open')
		if (isBurgerMenuOpen) {
			$('#menuLinks').removeClass('open')
			$('#menuLinks').addClass('hidden')
		}
	})

	$(document).on('click', '.favoris-button', function() {
		$(this).find('.heart-icon').click()
	})

	$(document).on('click', '[data-toggle-modal]', function(e) {
		e.preventDefault()
		const modal = $('dialog#' + $(this).data('toggle-modal'))
		$(this).closest('dialog').hideModal()
		modal.showModal()
	})

	$(document).on('click', '.stopPropagation', function(e) {
		e.stopPropagation()
	})

	$(document).on('click', '.updateModalPlan', function() {
		const idProgramme = $(this).data('idprogramme')
		const idBien = $(this).data('idbien')
		const numeroLot = $(this).data('numerolot')
		const programmeName = $(this).data('programmename')
		const customTitle = $(this).data('title')

		$('[name="idProgramme"]').val(idProgramme)
		$('[name="idBien"]').val(idBien)

		if (customTitle) {
			$('.modalTitle').html(customTitle)
		} else {
			$('.numeroLot').html(numeroLot)
			$('.programmeName').html(programmeName)
		}
	})

	document.querySelectorAll('input[name=\'phone\']').forEach((element) => {
		const parentFormId = $(element).closest('form').attr('id')
		phoneInputs[parentFormId] = window.intlTelInput(element, {
			initialCountry: 'fr',
			preferredCountries: ['fr'],
			separateDialCode: true,
			hiddenInput: 'telephoneHidden',
			utilsScript: '/assets/js/intlTelInput/utils.js'
		})

		// On rajoute un event à l'élément
		element.addEventListener('keyup', function() {
			phoneInputs[parentFormId].setNumber(element.value)

			let phoneNumber = ''

			if (phoneInputs[parentFormId].getSelectedCountryData().iso2 == 'fr') {
				phoneNumber = phoneInputs[parentFormId].getNumber(2)
			} else {
				phoneNumber = phoneInputs[parentFormId].getNumber(1)
			}

			$(this).parent().find('[name=\'telephoneHidden\']').val(phoneNumber)
		})

		if (element.value != '') {
			var value = element.value
			phoneInputs[parentFormId].setNumber('')
			phoneInputs[parentFormId].setNumber(value)
		}
	})

	$(document).on('click', '.close-modal', function(e) {
		e.preventDefault()
		const modal = $(this).closest('dialog')
		const form = modal.find('form')
		form.trigger('reset')
		modal.hideModal()
	})

	$(document).on('click', '.showModal', function(e) {
		e.preventDefault()
		const modal = $('#' + $(this).data('modal'))
		modal.showModal()
	})

	$('dialog').click(function(e) {
		const dialog = e.target
		const form = $(dialog).find('form')
		if (dialog.tagName === 'DIALOG') {
			dialog.close()
			form.trigger('reset')
			$('body').removeClass('overflow-hidden')
		}
	})

	$('#trouverAgenceBtn').click(function(e) {
		e.preventDefault()

		const geolocalisation = window.navigator.geolocation

		if (geolocalisation) {
			geolocalisation.getCurrentPosition(
				function(position) {
					const lat = position.coords.latitude
					const lng = position.coords.longitude

					$.ajax({
						url: '/api/agences/nearest',
						method: 'get',
						data: {
							lat: lat,
							lng: lng
						},
						dataType: 'json',
						success: function(data) {
							if (data.error) {
								$('.message').replaceClass('hidden', 'block')
								$('.message').html(data.error)
							} else {
								$('.infoBlocTrouverAgence').html(data.response)
							}
						}
					})
				},
				function(error) {
					console.log(error)
				}
			)
		} else {
			console.log('Geolocalisation non supportée')
		}
	})

	let length = 0
	let navHeight = 0
	const offreWrapper = $('.offreWrapper')
	const topNav = $('#topNav')
	const topNavMenu = $('#topNavMenu')

	if (offreWrapper.length) {
		length = parseFloat(offreWrapper.outerHeight())
	}

	navHeight = parseFloat(topNav.outerHeight()) + parseFloat(topNavMenu.outerHeight())

	$(window).scroll(function() {
		if (offreWrapper.length) {
			const windowScroll = $(window).scrollTop()
			if (windowScroll < parseFloat(offreWrapper.outerHeight())) {
				length = parseFloat(offreWrapper.outerHeight()) - parseFloat(windowScroll)
			} else {
				length = 0
			}
		}
	})

	$(window).resize(function() {
		navHeight = Math.round(parseFloat(topNav.outerHeight()) + parseFloat(topNavMenu.outerHeight()))
	})

	$('.dropdown').click(function(e) {
		const dropdownContent = $('#' + $(this).data('dropdown'))
		const svg = $(this).parent().find('svg')

		if (dropdownContent.hasClass('hidden')) {
			dropdownContent.addClass('open')
			dropdownContent.replaceClass('hidden', 'block')

			if ($(this).data('dropdown') == 'menuLinks') {
				dropdownContent.css('top', length + navHeight)
			}

			if ($(this).data('rotate') == true) {
				svg.addClass('rotate-180')
			}

			if ($(this).data('fixed') == true) {
				$('body').addClass('overflow-hidden')
			}
		} else {
			dropdownContent.removeClass('open')
			dropdownContent.replaceClass('block', 'hidden')
			if ($(this).data('rotate') == true) {
				svg.removeClass('rotate-180')
			}
			if ($(this).data('fixed') == true) {
				$('body').removeClass('overflow-hidden')
			}
		}
	})

	$(document).on('click', '.modal-backdrop', function() {
		const dialog = $('dialog[open]')
		dialog.find('form').trigger('reset')
		dialog.hideModal()
	})

	function generateSearchListItem(data) {
		return `<li class="text-xs flex items-center gap-2 p-4 cursor-pointer hover:bg-primary hover:text-white">
    ${data.ville} - ${data.cp}
    </li>`
	}
})

function openCity(event, imgSrc) {
	var time = new Date($.now()).getTime()
	$('#illustrationMenu').attr(
		'src',
		'https://doc.polyvalence-immobilier.fr/' + imgSrc + '?' + time
	)
}

// function myCallBack() {
//   $("button.recaptcha").each(function () {
//     var el = $(this);
//     console.log(el);
//     widgetId = grecaptcha.render($(el).attr("id"), {
//       sitekey: "6LeKVXoiAAAAACKwkveRrOaGVdaOD--IcyLORo86",
//       callback: function () {
//         el.closest("form").submit();
//       },
//     });
//     arrayWidgetId.push({
//       widgetId: widgetId,
//       recpatchaId: $(el).attr("id"),
//     });
//   });
// }